export default __webpack_public_path__ + "static/media/menu_black.cb3e8baf.svg";